import React from 'react';
import Icon from 'atomic/icon';
import classNames from 'classnames';

import './product-opinion-assessment.scss';

interface ProductOpinionAssessmentProps {
    pros: string[];
    cons: string[];
    className?: string;
}

const ProductOpinionAssessment: React.FC<ProductOpinionAssessmentProps> = ({
    pros,
    cons,
    className
}) => {
    if (!pros?.length && !cons?.length) {
        return null;
    }

    return (
        <div className={classNames('opinion-assessment', className)}>
            {
                (pros?.length > 0) && (
                    <div className="opinion-assessment__list">
                        <div className="opinion-assessment__header">
                            Zalety
                        </div>
                        {pros.map(prosItem => (
                            <div className="opinion-assessment__item opinion-assessment__item--pros" key={prosItem}>
                                <Icon name={'plus'} size={16} />
                                {prosItem}
                            </div>
                        ))}
                    </div>
                )
            }
            {
                (cons?.length > 0) && (
                    <div className="opinion-assessment__list">
                        <div className="opinion-assessment__header">
                            Wady
                        </div>
                        {cons.map(consItem => (
                            <div className="opinion-assessment__item opinion-assessment__item--cons" key={consItem}>
                                <Icon name={'minus'} size={16} />
                                {consItem}
                            </div>
                        ))}
                    </div>
                )
            }
        </div>
    );
};

export default ProductOpinionAssessment;
